import React from "react";
import { useTranslation } from "react-i18next";
import ToggleLinks from "../../../parts/inputs/toggle-links-input";

const AdminToggle = () => {
  const { t } = useTranslation("admin");
  return (
    <div className="Admin-Toggle">
      <ToggleLinks
        name="admin-toggle"
        options={[
          { text: t("toggle.users"), value: "users", href: "/admin/users" },
          {
            text: t("toggle.reports"),
            value: "reports",
            href: "/admin/reports",
          },
          {
            text: t("toggle.exerciseLibrary"),
            value: "exercise-library",
            href: "/admin/exercise-library",
          },
          {
            text: t("toggle.msbUniversity"),
            value: "tutorial-categories",
            href: "/admin/tutorials",
          },
          {
            text: "Announcements",
            value: "news",
            href: "/admin/news",
          },
          {
            text: "Import Program",
            value: "import-program",
            href: "/admin/import-program",
          },
          {
            text: "Import Meal Plan",
            value: "import-meal-plan",
            href: "/admin/import-meal-plan",
          },
        ]}
      />
    </div>
  );
};

export default AdminToggle;
